import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"
import { Col, Container, Row, Card, CardBody } from "reactstrap"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import { GetHelper } from '../Masters/CallHelper'
import { get, post } from 'helpers/api_helper'
import Toaster from "components/toster"
import "./flowConfig.css"

const FlowConfig = () => {
    const [items, setItems] = useState([])
    const [dropped, setDropped] = useState([])
    const onDragEnd = async (result) => {
    if (!result.destination) return;

    let newItems = Array.from(items);
    let newDropped = Array.from(dropped);

    // Left -> Right
    if (result.source.droppableId === "items" && result.destination.droppableId === "dropped") {
        const draggedItem = items[result.source.index];
        newItems.splice(result.source.index, 1);
        newDropped.splice(result.destination.index, 0, draggedItem);
    }

    // Right -> Left
    if (result.source.droppableId === "dropped" && result.destination.droppableId === "items") {
        const draggedItem = dropped[result.source.index];
        newDropped.splice(result.source.index, 1);
        newItems.splice(result.destination.index, 0, draggedItem);
    }

    // Reorder inside Right
    if (result.source.droppableId === "dropped" && result.destination.droppableId === "dropped") {
        const [moved] = newDropped.splice(result.source.index, 1);
        newDropped.splice(result.destination.index, 0, moved);
    }

    // Reorder inside Left
    if (result.source.droppableId === "items" && result.destination.droppableId === "items") {
        const [moved] = newItems.splice(result.source.index, 1);
        newItems.splice(result.destination.index, 0, moved);
    }

    // update states
    setItems(newItems);
    setDropped(newDropped);

    // save using the latest dropped state
    await configFlow(newDropped);
};

const configFlow = async (data) => {
    try {
        const res = await post(`/api/flow/config`, { data: JSON.stringify(data) });
        console.log("Flow saved:", res);
        Toaster('info', {message: '', title: 'Flow Updated.'})
    } catch (err) {
        console.error("Error saving flow:", err);
    }
};


const getFlow = async() => {
    const { status, response } = await get(`/api/flow/config`);
    if(status){
        return JSON.parse(response?.config_data);
    }
}

const getDepartments = async() => {
    const res = await GetHelper(`${process.env.REACT_APP_LABDEPARTMENT}&page=1&limit=200&search=`);
    if(res?.rows?.length){
        let deps = res?.rows.map(v => ({name: v.title, id: v.code}));
        const flow = await getFlow();
        deps = deps.filter(d => !flow.some(dr => dr.id === d.id));
        setItems(deps);
        setDropped(flow);
    }
}

useEffect(getDepartments,[])

return (
    <React.Fragment>
        <div className="page-content flow-config-wrapper">
            <MetaTags>
                <title>Workflow Config | Process</title>
            </MetaTags>
            <Container fluid>
                <Breadcrumbs title="Process" breadcrumbItem="Config" />
                <DragDropContext onDragEnd={onDragEnd}>
                    <Row>
                        {/* Column 1: Available Departments */}
                        <Col lg={4} md={12}>
                            <Card className="flow-card">
                                <div className="flow-card-header">
                                    <h5>
                                        <i className="bx bx-list-ul" /> Available Departments
                                    </h5>
                                    <span className="flow-badge-count">{items.length}</span>
                                </div>
                                <CardBody className="p-3">
                                    <Droppable droppableId="items">
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                className={`flow-dropzone ${snapshot.isDraggingOver ? "is-dragging-over-items" : ""}`}
                                            >
                                                {items.length === 0 ? (
                                                    <div className="flow-empty-state">
                                                        <i className="bx bx-info-circle flow-empty-icon" />
                                                        <div className="flow-empty-title">All Assigned</div>
                                                        <div className="flow-empty-desc">All departments have been added to the workflow.</div>
                                                    </div>
                                                ) : (
                                                    items.map((item, index) => (
                                                        <Draggable key={item.id} draggableId={item.id} index={index}>
                                                            {(prov, snap) => (
                                                                <div
                                                                    ref={prov.innerRef}
                                                                    {...prov.draggableProps}
                                                                    className={`flow-drag-item ${snap.isDragging ? "is-dragging" : ""}`}
                                                                >
                                                                    <div className="flow-item-content">
                                                                        <span {...prov.dragHandleProps} className="flow-drag-handle">
                                                                            <i className="bx bx-grid-vertical" />
                                                                        </span>
                                                                        <span className="flow-item-title">{item.name}</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))
                                                )}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </CardBody>
                            </Card>
                        </Col>

                        {/* Column 2: Selected Workflow */}
                        <Col lg={4} md={12}>
                            <Card className="flow-card">
                                <div className="flow-card-header">
                                    <h5>
                                        <i className="bx bx-transfer" /> Selected Workflow
                                    </h5>
                                    <span className="flow-badge-count">{dropped.length}</span>
                                </div>
                                <CardBody className="p-3">
                                    <Droppable droppableId="dropped">
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                className={`flow-dropzone ${snapshot.isDraggingOver ? "is-dragging-over-dropped" : ""}`}
                                            >
                                                {dropped.length === 0 ? (
                                                    <div className="flow-empty-state">
                                                        <i className="bx bx-move flow-empty-icon" />
                                                        <div className="flow-empty-title">Workflow Empty</div>
                                                        <div className="flow-empty-desc">Drag and drop departments here to build your pathway.</div>
                                                    </div>
                                                ) : (
                                                    dropped.map((item, index) => (
                                                        <Draggable key={item.id} draggableId={item.id} index={index}>
                                                            {(prov, snap) => (
                                                                <div
                                                                    ref={prov.innerRef}
                                                                    {...prov.draggableProps}
                                                                    className={`flow-drag-item ${snap.isDragging ? "is-dragging" : ""}`}
                                                                >
                                                                    <div className="flow-item-content">
                                                                        <span {...prov.dragHandleProps} className="flow-drag-handle">
                                                                            <i className="bx bx-grid-vertical" />
                                                                        </span>
                                                                        <span className="flow-item-title">{item.name}</span>
                                                                    </div>
                                                                    <span className="badge flow-badge flow-badge-success">Step {index + 1}</span>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))
                                                )}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </CardBody>
                            </Card>
                        </Col>

                        {/* Column 3: Stepper Preview */}
                        <Col lg={4} md={12}>
                            <Card className="flow-card">
                                <div className="flow-card-header">
                                    <h5>
                                        <i className="bx bx-git-commit" /> Pathway Preview
                                    </h5>
                                </div>
                                <CardBody className="p-4" style={{ minHeight: "520px", maxHeight: "620px", overflowY: "auto" }}>
                                    {dropped.length === 0 ? (
                                        <div className="flow-empty-state">
                                            <i className="bx bx-git-repo-forked flow-empty-icon" />
                                            <div className="flow-empty-title">No Workflow</div>
                                            <div className="flow-empty-desc">Add departments to see the step-by-step preview.</div>
                                        </div>
                                    ) : (
                                        <div className="flow-timeline-container">
                                            <div className="flow-timeline-line"></div>
                                            {dropped.map((item, index) => (
                                                <div className="flow-timeline-item" key={item.id}>
                                                    <div className="flow-timeline-badge">
                                                        {index + 1}
                                                    </div>
                                                    <div className="flow-timeline-card">
                                                        <div>
                                                            <h5 className="flow-timeline-card-title">{item.name}</h5>
                                                            <p className="flow-timeline-card-desc">
                                                                {index === 0
                                                                    ? "Workflow Entry Point"
                                                                    : index === dropped.length - 1
                                                                    ? "Workflow Exit Point"
                                                                    : `Processing Step ${index + 1}`}
                                                            </p>
                                                        </div>
                                                        <i
                                                            className={`bx ${
                                                                index === 0
                                                                    ? "bx-log-in-circle text-primary"
                                                                    : index === dropped.length - 1
                                                                    ? "bx-check-circle text-success"
                                                                    : "bx-right-arrow-alt text-muted"
                                                            }`}
                                                            style={{ fontSize: "1.25rem" }}
                                                        ></i>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </DragDropContext>
            </Container>
        </div>
    </React.Fragment>
    )
}

export default FlowConfig
